import React, { useContext } from "react";
import { Link } from "react-router-dom";
import marutilogo from "../../../../assets/images/marutilogo/marutiHeader.svg";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import * as actionType from "../../../../store/actions";

const NavLogo = () => {
  const configContext = useContext(ConfigContext);
  const { collapseMenu } = configContext.state;
  const { dispatch } = configContext;
  let toggleClass = ["mobile-menu"];
  if (collapseMenu) {
    toggleClass = [...toggleClass, "on"];
  }

  return (
    <React.Fragment>
      <div className="navbar-brand header-logo bg-white">
        <Link
          to="#"
          className={toggleClass.join(" ")}
          id="mobile-collapse"
          onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}
        >
          <span />
        </Link>
        <span className="b-title">
          <img
            className="b-image"
            width="206px"
            src={marutilogo}
            alt="Maruti Logo"
          />
        </span>
      </div>
    </React.Fragment>
  );
};

export default NavLogo;
